import * as React from "react";
import CclDrawer from "../../../../../components/common/cclDrawer/cclDrawer";
import TrainerEntryDataGrid from "./trainerEntryDataGrid";

export interface TrainerEntryDrawerProps {
    sessionId: string;
    projectCode: string;
    open: boolean;
    onClose: () => void;
}

const TrainerEntryDrawer: React.FC<TrainerEntryDrawerProps> = (props) => {
    return (
        <CclDrawer 
            title="Faculty Entry" 
            open={props.open} 
            onClose={props.onClose}
            width="wide"
        >
            <TrainerEntryDataGrid sessionId={props.sessionId} projectCode={props.projectCode} />
        </CclDrawer>
    );
};

export default TrainerEntryDrawer;
